import { HelpCenter } from '@/features/help-center';

/** The in-app guide (`/app/help`); the header's "?" opens it. */
export function HelpPage() {
  return <HelpCenter />;
}
